import { PitchListHelper } from 'classes/helpers/pitch-list.helper';
import { ErrorBoundary } from 'components/common/error-boundary';
import { SessionRecap } from 'components/sections/analytics/session-hits/recap';
import { MachineContext } from 'contexts/machine.context';
import { useContext } from 'react';
import { useAuthStore } from 'stores/use-auth-store';
import useHittersStore from 'stores/use-hitters-store';

export const PitchListHittingResultsNew = () => {
  const current = useAuthStore((s) => s.current);
  const { session: sessionID } = current;

  const activeHitter = useHittersStore((s) => s.activeHitter);

  const { machine } = useContext(MachineContext);

  const hitterID = PitchListHelper.getSafeHitterID(activeHitter);

  return (
    <ErrorBoundary identifier="PitchListHittingResults">
      <SessionRecap
        sessionID={sessionID}
        hitterID={hitterID}
        machineID={machine?.machineID}
        header={null}
      />
    </ErrorBoundary>
  );
};
